import TableHeader from 'emerald-ui/lib/TableHeader';
import TableHeaderCell from 'emerald-ui/lib/TableHeaderCell';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: TableHeader, componentName: 'TableHeader' }], 'TableHeader'),
  description: 'An interactive and customizable header for the Table with selection and ordering features.',
  codeSamples: [
    {
      title: 'Default',
      scope: { TableHeader, TableHeaderCell },
      code: `<div style={{ overflow: 'auto' }}>
  <table className="eui-table">
    <TableHeader checkboxAriaLabel="Name" sortBy="name">
      <TableHeaderCell sortKey="name">Name</TableHeaderCell>
      <TableHeaderCell sortKey="role">Role</TableHeaderCell>
      <th>Group</th>
    </TableHeader>
  </table>
</div>`,
    },
  ],
};
